import { memo, useCallback, useState } from "react";
import "./Advertising.scss";
import HeroAdvertising from "./components/Hero/HeroAdvertising/HeroAdvertising";
import Advantages from "./components/Advantages/Advantages";
import Reach from "./components/Reach/Reach";
import AdContactForm from "./components/AdContactForm/AdContactForm";
import AdvertisingPolicies from "./components/AdvertisingPolicies/AdvertisingPolicies";
import useAdvertising from "./hooks/useAdvertising";

const Advertising = memo(() => {
  const [isHeroBunnerScrolledToTop, setIsHeroBunnerScrolledToTop] =
    useState(false);
  const { handleScrollToForm } = useAdvertising();

  const handleScroll = useCallback(() => {
    handleScrollToForm(setIsHeroBunnerScrolledToTop);
  }, [handleScrollToForm]);

  return (
    <div className="advertising-section-content">
      <HeroAdvertising
        handleScrollToForm={handleScroll}
        isHeroBunnerScrolledToTop={isHeroBunnerScrolledToTop}
        setIsHeroBunnerScrolledToTop={setIsHeroBunnerScrolledToTop}
      />
      <Advantages />
      <Reach handleScrollToForm={handleScroll} />
      <AdContactForm />
      <AdvertisingPolicies />
    </div>
  );
});

export default Advertising;
